import React from "react";
import Box from "@mui/material/Box";
import GroupDetailProfile from "./GroupDetailProfile";

export default function GroupDetailHeaderBand({ group }) {
  return (
    <Box
      sx={{
        bgcolor: "#FFF",
        px: 3,
        pt: 2,
        pb: 2,
        borderBottom: "1px solid #E5E9EC",
        flexShrink: 0,
      }}
    >
      <GroupDetailProfile group={group} />
    </Box>
  );
}
